import { call, put } from "redux-saga/effects";
import { Creators } from ".";
import { api, ResponseError } from "../../services";

export default function* getRolesAssociatedList() {
  try {
    const response = yield call(api.getRolesAssociatedList);

    yield put(Creators.getRolesAssociatedListSuccess(response));
  } catch (response) {
    const errorResponse = new ResponseError(response);
    errorResponse.alertMessage();
    yield put(Creators.getRolesAssociatedListFailure());
  }
}
